import React from 'react';
import { IconProps } from '../../../../../types/components';

export default function Heart({ iconClass, width }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      focusable="false"
      role="img"
      viewBox="0 0 18 16"
      className={iconClass}
      width={width}
    >
      <path d="M7.91016 15.2383L7.83984 15.1328L1.6875 9.4375C0.597656 8.41797 0 7.01172 0 5.53516V5.42969C0 2.96875 1.75781 0.824219 4.18359 0.367188C5.55469 0.0859375 6.96094 0.402344 8.12109 1.21094C8.4375 1.42188 8.71875 1.70312 9 1.98438C9.14062 1.84375 9.28125 1.66797 9.45703 1.52734C9.59766 1.42188 9.73828 1.31641 9.87891 1.21094C11.0039 0.402344 12.4102 0.0859375 13.7812 0.367188C16.2422 0.824219 18 2.96875 18 5.42969V5.53516C18 7.01172 17.3672 8.41797 16.2773 9.4375L10.125 15.1328L10.0547 15.2383C9.77344 15.4844 9.38672 15.6602 9 15.6602C8.57812 15.6602 8.22656 15.4844 7.91016 15.2383ZM8.40234 3.84766C8.36719 3.84766 8.36719 3.84766 8.36719 3.8125L7.73438 3.10938C6.92578 2.19531 5.69531 1.80859 4.5 2.01953C2.84766 2.33594 1.6875 3.77734 1.6875 5.42969V5.53516C1.6875 6.55469 2.07422 7.50391 2.8125 8.17188L9 13.9023L15.1523 8.17188C15.8906 7.50391 16.3125 6.55469 16.3125 5.53516V5.42969C16.3125 3.77734 15.1172 2.33594 13.4648 2.01953C12.2695 1.80859 11.0391 2.19531 10.2305 3.10938L9.59766 3.8125C9.59766 3.84766 9.59766 3.84766 9.5625 3.88281C9.42188 4.02344 9.21094 4.12891 9 4.12891C8.75391 4.12891 8.54297 4.02344 8.40234 3.88281V3.84766Z" />
    </svg>
  );
}
